import type { ShipmentFlowState } from '../../../core/services/shipment-flow-state.service';
import { formatShipmentDateForPsa } from '../../service-step/sections/delivery-service-selection/build-delivery-service-requests';

/**
 * Returns true when Review & Pay must re-call Estimates Manager because the
 * scheduled pickup date differs from the ship date that priced the selected service (OM-754).
 * Falls back to today's PSA ship date when the selection does not yet store `shipmentDate`.
 */
export function shouldRefreshEstimateForPickup(
  state: ShipmentFlowState | null,
  todayShipDate: string = formatShipmentDateForPsa(),
): boolean {
  if (!state?.selectedService?.productCode?.trim()) {
    return false;
  }

  const pickup = state.pickupDropOff;
  if (pickup?.method !== 'pickup') {
    return false;
  }

  const pickupDate = pickup.selectedDate?.trim() ?? '';
  if (!/^\d{4}-\d{2}-\d{2}$/.test(pickupDate)) {
    return false;
  }

  const shipmentDate = state.selectedService.shipmentDate?.trim() || todayShipDate;
  return pickupDate !== shipmentDate;
}
